import { render } from "./ContactView.vue?vue&type=template&id=2ea64ebc&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=2ea64ebc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ea64ebc"

export default script